import { useCallback, useEffect, useState } from "react";

import { useNotify } from "data/messages/hooks";

import useQueryNotInvitedUsers from "./useQueryNotInvitedUsers";
import useSubmitNewUsers from "./useSubmitNewUsers";

function useAddUser(
  initialUsers,
  onAdded,
  onClose,
  loadNotInvitedUser = true,
  defaultInviteNow = false
) {
  const notifyAddUserModalCompleted = useNotify("ADD_USER_COMPLETED");
  const notifyAddUserCancelled = useNotify("ADD_USER_CANCELLED");
  const {
    userList,
    defaultRole,
    roles,
    loading: loadingNotInvitedUser,
  } = useQueryNotInvitedUsers(loadNotInvitedUser);
  const [userInfos, setUserInfos] = useState(initialUsers);
  const { submit, loading } = useSubmitNewUsers({
    onDone: useCallback(
      ({ newUsers }) => {
        setUserInfos([]);
        onAdded();
        notifyAddUserModalCompleted(newUsers);
      },
      [setUserInfos, notifyAddUserModalCompleted, onAdded]
    ),
  });

  useEffect(() => {
    const emptyUserInfo = {
      firstName: "",
      lastName: "",
      email: "",
      roleId: "",
      inviteNow: defaultInviteNow,
    };
    if (!loadingNotInvitedUser) {
      setUserInfos((prev) => {
        return prev.concat([...userList, emptyUserInfo]);
      });
    }
  }, [userList, loadingNotInvitedUser, setUserInfos, defaultInviteNow]);

  const onSubmit = useCallback(
    async (data = null) => {
      await submit(
        { userInfos: data || userInfos },
        {
          successMsg: "Users added successfully",
          defaultErrorMsg: "Failed to add users",
        }
      );
    },
    [userInfos, submit]
  );

  return {
    onSubmit: onSubmit,
    loading: loading,
    roles: roles,
    defaultRole: defaultRole,
    loadingNotInvitedUser:
      loadingNotInvitedUser ||
      (!loadingNotInvitedUser && userInfos.length === 0),
    setUserInfos: setUserInfos,
    userInfos: userInfos,
    onCloseWithNotify: () => {
      notifyAddUserCancelled([true]);
      onClose();
    },
  };
}

export default useAddUser;
